<div *ngIf="visible && info" class="mb-3 p-3 rounded-xl bg-white/5 border border-white/10">
  <!-- Estado actual -->
  <div class="flex items-center justify-between mb-2">
    <div class="flex items-center gap-2">
      <span class="h-2 w-2 rounded-full shrink-0"
        [ngClass]="{
          'bg-green-400': info.status === 'AVAILABLE',
          'bg-amber-400': info.status === 'BREAK' || info.status === 'LUNCH',
          'bg-slate-500': info.status === 'CHECKED_OUT'
        }"></span>
      <span class="text-[11px] font-semibold text-white">{{ statusLabel }}</span>
    </div>
    <span *ngIf="(info.status === 'BREAK' || info.status === 'LUNCH') && remaining > 0"
      class="text-[11px] font-mono font-bold text-amber-300">{{ countdownLabel }}</span>
  </div>

  <!-- Botones (solo cuando está disponible) -->
  <div *ngIf="info.status === 'AVAILABLE'" class="grid grid-cols-3 gap-1.5">
    <button (click)="ask('break')" [disabled]="!info.break?.enabledNow"
      [title]="info.break?.left > 0 ? (info.break?.left + ' descanso(s) restante(s)') : 'Sin descansos disponibles'"
      class="flex flex-col items-center gap-0.5 px-1 py-1.5 rounded-lg text-[10px] font-semibold transition-colors disabled:opacity-30 disabled:cursor-not-allowed text-slate-200 bg-white/5 hover:bg-white/10 hover:text-white">
      <lucide-icon name="coffee" class="h-3.5 w-3.5"></lucide-icon>
      Descanso<span *ngIf="info.break?.left != null" class="text-[9px] opacity-70">({{ info.break.left }})</span>
    </button>
    <button (click)="ask('lunch')" [disabled]="!info.lunch?.enabledNow"
      [title]="info.lunch?.used ? 'Almuerzo ya usado hoy' : ('Disponible ' + info.lunch?.windowStart + '–' + info.lunch?.windowEnd)"
      class="flex flex-col items-center gap-0.5 px-1 py-1.5 rounded-lg text-[10px] font-semibold transition-colors disabled:opacity-30 disabled:cursor-not-allowed text-slate-200 bg-white/5 hover:bg-white/10 hover:text-white">
      <lucide-icon name="utensils" class="h-3.5 w-3.5"></lucide-icon>
      Almuerzo
    </button>
    <button (click)="ask('checkout')" [disabled]="!info.checkout?.enabledNow"
      [title]="'Disponible desde ' + info.checkout?.time"
      class="flex flex-col items-center gap-0.5 px-1 py-1.5 rounded-lg text-[10px] font-semibold transition-colors disabled:opacity-30 disabled:cursor-not-allowed text-slate-200 bg-white/5 hover:bg-white/10 hover:text-white">
      <lucide-icon name="log-out" class="h-3.5 w-3.5"></lucide-icon>
      Salida
    </button>
  </div>

  <!-- Aviso cuando no está disponible -->
  <p *ngIf="info.status === 'BREAK' || info.status === 'LUNCH'" class="text-[10px] text-slate-400 leading-tight">
    No se te asignarán chats nuevos hasta que termine.
  </p>
  <p *ngIf="info.status === 'CHECKED_OUT'" class="text-[10px] text-slate-400 leading-tight">
    Marcaste tu salida. Volverás a estar activo mañana.
  </p>
</div>
